import { useLang } from "../i18n";
import { cn } from "../lib/utils";

/**
 * Single reusable brand logo (round badge).
 * Never stretched/cropped/squeezed: object-contain, fixed aspect square,
 * circular, centered, and responsive (~56px mobile / ~80px desktop).
 */
export const Logo = ({ className = "", size, ...props }) => (
  <img
    src="/brand/badge.png"
    alt="Little Friends Coffee"
    data-testid="brand-mark"
    className={cn(
      "aspect-square shrink-0 rounded-full object-contain object-center shadow-sm ring-1 ring-[#26422A]/10",
      "h-14 w-14 md:h-20 md:w-20",
      className
    )}
    {...props}
  />
);

// Backwards-compatible alias so existing imports keep working.
export const BrandMark = Logo;

// Header identity: standardized logo + stacked name.
export const BrandWordmark = () => {
  const { t } = useLang();
  return (
    <div className="flex items-center gap-3" data-testid="brand-wordmark">
      <Logo />
      <div className="leading-tight">
        <div className="font-display text-lg font-black text-[#26422A]">
          {t("brandName")}
        </div>
        <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#26422A]">
          {t("brandTagline")}
        </div>
      </div>
    </div>
  );
};

// Full arched lockup image for hero/marketing use.
export const BrandLockup = ({ className = "" }) => (
  <img
    src="/brand/logo-full.jpeg"
    alt="Little Friends Coffee"
    className={cn("select-none object-contain mix-blend-multiply", className)}
  />
);

// Line-art hamster mascot.
export const BrandMascot = ({ className = "" }) => (
  <img
    src="/brand/mascot.jpeg"
    alt=""
    aria-hidden="true"
    className={cn("select-none object-contain mix-blend-multiply", className)}
  />
);
